import { useEffect, useState } from "react";

const enterKey = 13;

const useAccessibleSubmit = (value: string, onSubmit: (value: string) => void, cartLoadedTime?: number) => {
    const [stateValue, setValue] = useState(value);

    const handleValidation = (value: string) => {
        const inputQty = parseFloat(value);
        if (Number.isNaN(inputQty)) {
            return "";
        }
        return inputQty <= 999999 ? inputQty.toString() : "999999";
    };

    const changeHandler = (event: any) => {
        setValue(handleValidation(event.currentTarget.value));
    };

    const keyDownHandler = (event: any) => {
        if (event.keyCode === enterKey) {
            event.stopPropagation();
            onSubmit(handleValidation(stateValue));
        }
    };

    const blurHandler = () => {
        if (value !== String(stateValue)) {
            onSubmit(handleValidation(stateValue));
        }
    };

    useEffect(() => {
        setValue(value);
    }, [value, cartLoadedTime]);

    return {
        value: stateValue,
        changeHandler,
        keyDownHandler,
        blurHandler,
    };
};

export default useAccessibleSubmit;
